import { StrictDict } from '../../../utils';

import app from './app';
import video from './video';
import problem from './problem';

export default StrictDict({
  app,
  video,
  problem,
});
